import { BlackLikeIcon, LikeIcon } from '@/assets/icons';
import { notification } from '@/constants/notification';
import { useUser } from '@/contexts/AuthContext';
import {
  GetLikesByPostIdDocument,
  useGetLikesByPostIdQuery,
  useLikePostByPkMutation,
  useUnlikePostByPkMutation,
} from '@/generated/graphql';
import { useApollo } from '@/lib/apolloClient';
import { useRouter } from 'next/router';
import React from 'react';
import toast from 'react-hot-toast';

interface IShareSection {
  postId: number;
}
const ShareSection = ({ postId }: IShareSection) => {
  const router = useRouter();
  const { user } = useUser();
  const apolloClient = useApollo({});
  const { data } = useGetLikesByPostIdQuery({
    variables: {
      where: {
        id: {
          _eq: postId,
        },
      },
      postsLikesWhere2: {
        created_by_id: {
          _eq: user?.userId,
        },
      },
    },
  });

  const { postsLikesCount, postsLikes } = data?.posts[0] || {};

  const isLiked = postsLikes && postsLikes?.length > 0;
  const [mutationUnlike] = useUnlikePostByPkMutation();

  const [mutationLike] = useLikePostByPkMutation();

  const onClickLike = async () => {
    try {
      await mutationLike({
        variables: {
          objects: {
            post_id: postId,
          },
        },
      });
      toast.success(notification.reaction.success);
      apolloClient.refetchQueries({
        include: [GetLikesByPostIdDocument],
      });
    } catch (error) {
      toast.success(notification.reaction.fail);
    }
  };

  const onClickUnLike = async () => {
    try {
      await mutationUnlike({
        variables: {
          deletePostsLikesByPkId: postsLikes?.[0]?.id,
        },
      });
      toast.success(notification.reaction.unlike);
      apolloClient.refetchQueries({
        include: [GetLikesByPostIdDocument],
      });
    } catch (error) {
      toast.success(notification.reaction.unlikeFail);
    }
  };

  return (
    <div className="w-full bg-[#D9D9D9] p-2 flex justify-between rounded-lg">
      <div className="flex gap-2">
        {user && !isLiked && (
          <button
            onClick={onClickLike}
            className={`rounded-lg bg-primary text-white flex gap-1 items-center px-2 py-1`}
          >
            <LikeIcon />
            Thích {postsLikesCount?.count}
          </button>
        )}
        {user && isLiked && (
          <button
            onClick={onClickUnLike}
            className="rounded-lg bg-primary/40 text-black flex gap-1 items-center px-2 py-1"
          >
            <BlackLikeIcon />
            Thích {postsLikesCount?.count}
          </button>
        )}
        {!user && (
          <button
            onClick={() => router.push('/account')}
            className={`rounded-lg bg-primary text-white flex gap-1 items-center px-2 py-1`}
          >
            <LikeIcon />
            Thích {postsLikesCount?.count}
          </button>
        )}
      </div>
    </div>
  );
};

export default ShareSection;
